import { render, staticRenderFns } from "./AdminCollections.vue?vue&type=template&id=5673119b&scoped=true"
import script from "./AdminCollections.vue?vue&type=script&lang=ts"
export * from "./AdminCollections.vue?vue&type=script&lang=ts"
import style0 from "./AdminCollections.vue?vue&type=style&index=0&id=5673119b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5673119b",
  null
  
)

export default component.exports